import { render, staticRenderFns } from "./MessageHistory.vue?vue&type=template&id=6196de86&scoped=true&"
import script from "./MessageHistory.vue?vue&type=script&lang=ts&"
export * from "./MessageHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MessageHistory.vue?vue&type=style&index=0&id=6196de86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196de86",
  null
  
)

export default component.exports